export const primaryBlue = '#38B2E3';
